<template>
  <div>
    <el-dropdown
      trigger="hover"
      @visible-change="handleVisible"
      :hide-on-click="false"
      :show-timeout="0"
      :hide-timeout="200"
      :tabindex="-1"
    >
      <div class="avatar-content nav-bar-item">
        <img class="icon icon-w" :src="imgSrc16" alt="" />
        <span class="user-name">{{ userInfo.userName }}</span>
      </div>
      <el-dropdown-menu
        slot="dropdown"
        class="user-dropdown-content"
        @mouseenter="handleDropdownMouseEnter"
        @mouseleave="handleDropdownMouseLeave"
      >
        <QSCard :btnList="btnList">
          <template #titleBox>
            <img class="icon icon-n" :src="imgSrc40" alt="" />
            <div class="user-box">
              <span class="user-name">{{ userInfo.userName }}</span>
              <div class="user-role">
                <QS-clamp-lines
                  :lines="1"
                  :text="userInfo.roleName"
                  :showPop="false"
                  :isAllowExtra="true"
                />
              </div>
            </div>
          </template>
          <template #infoBox>
            <div class="item" v-if="userInfo.userAccount">
              <div class="title">
                <i class="icon QS-icon-account" />
                <span class="label">{{ userInfo.userAccount }}</span>
              </div>
            </div>
            <div class="item" v-if="userInfo.userMobile">
              <div class="title">
                <i class="icon QS-icon-phone" />
                <span class="label">{{ userInfo.userMobile }}</span>
              </div>
            </div>
            <div class="item other-item" v-if="userInfo.bindings.length" @click="unbindWechat">
              <div class="title">
                <svg-icon icon-class="ic-unbinding" class="icon" />
                <span class="label">解绑微信</span>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
          <template #customBox>
            <div class="sys-version" v-if="sysVersion">
              系统版本号{{ sysVersion }}
            </div>
          </template>
        </QSCard>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import QSCard from '@/components/QSCard/index.vue'
import { mapGetters } from 'vuex'
import avatar16 from '../assets/avatar-16.png'
import avatar40 from '../assets/avatar-40.png'

export default {
  components: {
    QSCard,
  },
  computed: {
    ...mapGetters(['userInfo']),
    avatar() {
      const arr = this.getURL({
        data: this.userInfo.avatar,
        needName: true,
      })
      if (!Array.isArray(arr) || arr.length === 0) {
        return null
      }
      return arr[0].url
    },
    imgSrc16() {
      return this.avatar || this.avatar16
    },
    imgSrc40() {
      return this.avatar || this.avatar40
    },
  },
  data() {
    return {
      avatar16,
      avatar40,
      isShow: false,
      sysVersion: '',
      hoverTimer: null,
      btnList: [
        {
          type: 'confirm',
          text: '退出登录',
          event: this.logout,
          style: {
            width: '100%',
          },
        },
      ],
    }
  },
  methods: {
    handleVisible(flag) {
      // 防抖处理，防止闪烁
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }

      if (flag) {
        // 立即显示，无延迟
        this.isShow = true
      } else {
        // 延迟隐藏，防止鼠标快速移动导致的闪烁
        this.hoverTimer = setTimeout(() => {
          this.isShow = false
          this.hoverTimer = null
        }, 150)
      }
    },

    handleDropdownMouseEnter() {
      // 鼠标进入下拉菜单时，取消隐藏定时器
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
    },

    handleDropdownMouseLeave() {
      // 鼠标离开下拉菜单时，延迟隐藏
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
      }
      this.hoverTimer = setTimeout(() => {
        this.isShow = false
        this.hoverTimer = null
      }, 150)
    },
    unbindWechat() {
      this.$confirm('确定要解除微信绑定么，你可以随时重新绑定。', '解绑微信', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        return this.$store.dispatch('UnbindWechat')
      }).then(() => {
        this.$message.success('解绑成功')
      }).catch(() => {
        // do nothing
      })
    },
    logout() {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
          setTimeout(() => {
            sessionStorage.removeItem('oldStartIndex')
          }, 10)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录',
          })
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.avatar-content {
  padding: 12px 16px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  border-radius: 6px;
  user-select: none;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .icon {
    font-size: 16px;
    margin-right: 10px;
  }
}
.user-box {
  width: 100%;
  overflow: hidden;
}
.user-role {
  width: 100%;
  overflow: hidden;
}

.user-dropdown-content {
  width: 260px;
  padding: 0px;
  border-radius: 8px;
  margin-top: 0;

  .title-box {
    display: flex;
    align-items: center;

    .icon {
      font-size: 40px;
      margin-right: 6px;
    }
  }

  .item {
    padding: 4px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: center;
      .icon {
        display: inline-block;
        margin-right: 5px;
        flex-shrink: 0;
      }

      .label {
        color: rgba(0, 0, 0, 0.7);
        word-break: break-all;
        white-space: normal;
      }
    }
  }

  .other-item {
    cursor: pointer;
  }

  .sys-version {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.3);
    text-align: center;
  }
}
.icon-w {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.icon-n {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
